module.exports = __webpack_public_path__ + "84c903b415594ccbe40119c6dc5c6ff1.svg";